import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=690e9d71&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=ts&"
export * from "./Logo.vue?vue&type=script&lang=ts&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=690e9d71&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e9d71",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixImg: require('/root/project/frontend/src/components/images/BixImg.vue').default,BixLink: require('/root/project/frontend/src/components/BixLink.vue').default})
